import { Container } from '@mui/material';
import CreateTeam from 'components/pages/createTeam/CreateTeam';
import IncorporationForm from 'components/pages/incorporationForm/IncorporationForm';
import Invitations from 'components/pages/invitations/Invitations';
import Kam from 'components/pages/kam/Kam';
import ListMentoring from 'components/pages/ListMentoring';
import ListRequest from 'components/pages/listRequest/ListRequest';
import RoomPage from 'components/pages/meeting/room/Room';
import Mentee from 'components/pages/mentee/Mentee';
import Mentor from 'components/pages/mentor/mentor';
import NotFound from 'components/pages/notFound/NotFound';
import Report from 'components/pages/report/Report';
import { PromptsPage } from 'components/pages/request/prompt/PromptsPage';
import Request from 'components/pages/request/Request';
import RoadmapManager from 'components/pages/roadmapManager/RoadmapManager';
import Teams from 'components/pages/teams/Teams';
import Unauthorized from 'components/pages/unauthorized/Unauthorized';
import UpdateTeam from 'components/pages/updateTeam/UpdateTeam';
import LoginStatus from 'components/ui/login/LoginStatus';
import React, { useContext } from 'react';
import { Redirect, Route, BrowserRouter as Router, Switch, useLocation } from 'react-router-dom';
import { AuthContext } from 'services/authContext/AuthContextProvider';
import ROL from 'utils/Roles';
import DetailsCandidate from '../components/pages/detailsCandidate/DetailsCandidate';
import ListCandidate from '../components/pages/listCandidate/ListCandidate';
import Login from '../components/pages/login/Login';
import NewCandidate from '../components/pages/newCandidate/NewCandidate';
import Register from '../components/pages/register/Register';
import ShowRoomCandidate from '../components/pages/showRoomCandidate/ShowRoomCandidate';
import Unsubscribe from '../components/pages/unsubscribe/Unsubscribe';
import LoginContainer from '../components/ui/login/LoginContainer';
import MenuBar from '../components/ui/menu/MenuBar';
import CandidateFinder from '../components/pages/candidateFinder/CandidateFinder';
import { PublicView } from 'components/ui/publicView/PublicView';

type Role = ROL | 'PUBLIC';

interface RouteItem {
  path: string;
  component: React.ComponentType;
}

interface RenderSwitchProps {
  routes: RouteItem[];
  redirectPath: string;
}

const Routes = () => {
  const { storeAuth } = useContext(AuthContext)!;
  const { user } = storeAuth;
  if (storeAuth?.isAuth && !user?.role) {
    storeAuth.isAuth = false;
  }

  const commonRoutes: RouteItem[] = [
    {
      path: '/unsubscribe',
      component: Unsubscribe,
    },
    {
      path: '/unauthorized',
      component: Unauthorized,
    },
    {
      path: '/notFound',
      component: NotFound,
    },
  ];

  const meetingRoutes: RouteItem[] = [
    {
      path: '/meeting/:idMentee/:typeOfInterview',
      component: RoomPage,
    },
  ];

  const administradorRoutes: RouteItem[] = [
    {
      path: '/kam/:idMentee',
      component: Kam,
    },
    {
      path: '/',
      component: ListCandidate,
    },
    {
      path: '/invitations',
      component: Invitations,
    },
    {
      path: '/report',
      component: Report,
    },
    {
      path: '/list/requests',
      component: ListRequest,
    },
    {
      path: '/request',
      component: Request,
    },
    {
      path: '/request/:requestId/editar',
      component: Request,
    },
    {
      path: '/request/:requestId/editar/prompt/:promptId',
      component: PromptsPage,
    },
    {
      path: '/candidate/new',
      component: NewCandidate,
    },
    {
      path: '/candidate/:phone/edit',
      component: NewCandidate,
    },
    {
      path: '/candidate/:phone/view',
      component: DetailsCandidate,
    },
    {
      path: '/candidate/search',
      component: CandidateFinder,
    },
    {
      path: '/showroom',
      component: ShowRoomCandidate,
    },
    {
      path: '/mentor',
      component: ListMentoring,
    },
    {
      path: '/kam',
      component: ListMentoring,
    },
    {
      path: '/mentored/:idMentee',
      component: Mentor,
    },
    {
      path: '/mentored/:idMentee/roadmap',
      component: RoadmapManager,
    },
    {
      path: '/mentee',
      component: Mentee,
    },
    {
      path: '/mentee/:idMentee',
      component: Mentee,
    },
    {
      path: '/teams',
      component: Teams,
    },
    {
      path: '/teams/create',
      component: CreateTeam,
    },
    {
      path: '/teams/:idMentee/edit',
      component: UpdateTeam,
    },
  ];

  const mentorRoutes: RouteItem[] = [
    {
      path: '/mentor',
      component: ListMentoring,
    },
    {
      path: '/kam',
      component: ListMentoring,
    },
    {
      path: '/kam/:idMentee',
      component: Kam,
    },
    {
      path: '/mentored/:idMentee',
      component: Mentor,
    },
    {
      path: '/mentored/:idMentee/roadmap',
      component: RoadmapManager,
    },
    {
      path: '/mentee/:idMentee',
      component: Mentee,
    },
    {
      path: '/teams',
      component: Teams,
    },
    {
      path: '/teams/create',
      component: CreateTeam,
    },
    {
      path: '/teams/:idMentee/edit',
      component: UpdateTeam,
    },
  ];

  const kamRoutes: RouteItem[] = [
    {
      path: '/mentored/:idMentee',
      component: Mentor,
    },
    {
      path: '/kam/:idMentee',
      component: Kam,
    },
    {
      path: '/teams/create',
      component: CreateTeam,
    },
    {
      path: '/teams/:idMentee/edit',
      component: UpdateTeam,
    },
    {
      path: '/teams',
      component: Teams,
    },
    {
      path: '/mentor',
      component: ListMentoring,
    },
    {
      path: '/kam',
      component: ListMentoring,
    },
    {
      path: '/mentored/:idMentee/roadmap',
      component: RoadmapManager,
    },
    {
      path: '/mentee/:idMentee',
      component: Mentee,
    },
  ];

  const usuarioRoutes: RouteItem[] = [
    {
      path: '/showroom',
      component: ShowRoomCandidate,
    },
    {
      path: '/candidate/:phone/view',
      component: DetailsCandidate,
    },
  ];

  const reclutadorRoutes: RouteItem[] = [
    {
      path: '/',
      component: ListCandidate,
    },
    {
      path: '/invitations',
      component: Invitations,
    },
    {
      path: '/report',
      component: Report,
    },
    {
      path: '/list/requests',
      component: ListRequest,
    },
    {
      path: '/request',
      component: Request,
    },
    {
      path: '/request/:requestId/editar',
      component: Request,
    },
    {
      path: '/request/:requestId/editar/prompt/:promptId',
      component: PromptsPage,
    },
    {
      path: '/candidate/new',
      component: NewCandidate,
    },
    {
      path: '/candidate/:phone/edit',
      component: NewCandidate,
    },
    {
      path: '/candidate/:phone/view',
      component: DetailsCandidate,
    },
    {
      path: '/showroom',
      component: ShowRoomCandidate,
    },
  ];

  const menteeRoutes: RouteItem[] = [
    {
      path: '/',
      component: Mentee,
    },
    {
      path: '/mentee/:idMentee',
      component: Mentee,
    },
  ];

  const employeeRoutes: RouteItem[] = [
    {
      path: '/',
      component: IncorporationForm,
    },
  ];

  const publicRoutes: RouteItem[] = [
    {
      path: '/',
      component: Login,
    },
    {
      path: '/register',
      component: Register,
    },
    {
      path: '/StatusRequest',
      component: LoginStatus,
    },
    {
      path: '/publicview/:hashCandidate',
      component: PublicView,
    },
  ];

  const roleRoutes: Record<Role, RouteItem[]> = {
    [ROL.ADMINISTRADOR]: [...commonRoutes, ...administradorRoutes],
    [ROL.USUARIO]: [...commonRoutes, ...usuarioRoutes],
    [ROL.RECLUTADOR]: [...commonRoutes, ...reclutadorRoutes],
    [ROL.MENTOR]: [...commonRoutes, ...mentorRoutes],
    [ROL.MENTEE]: [...commonRoutes, ...menteeRoutes],
    [ROL.KAM]: [...commonRoutes, ...kamRoutes],
    [ROL.EMPLOYEE]: [...commonRoutes, ...employeeRoutes],
    PUBLIC: [...commonRoutes, ...publicRoutes],
  };

  const redirectPaths: Record<Role, string> = {
    [ROL.ADMINISTRADOR]: '/',
    [ROL.USUARIO]: '/showroom',
    [ROL.RECLUTADOR]: '/',
    [ROL.MENTOR]: '/mentored',
    [ROL.MENTEE]: '/',
    [ROL.KAM]: '/mentored',
    [ROL.EMPLOYEE]: '/',
    PUBLIC: '/',
  };

  const RenderSwitch = ({ routes, redirectPath }: RenderSwitchProps) => {
    // Get actual path using react router
    const actualPath = useLocation().pathname;

    if (actualPath.includes('editar/prompt')) {
      return (
        <Switch>
          {routes.map((route) => {
            return <Route exact path={route.path} component={route.component} key={route.path} />;
          })}
          <Redirect to={redirectPath} />
        </Switch>
      );
    }

    return (
      <Container maxWidth='xl' sx={{ py: 2 }}>
        <Switch>
          {routes.map((route) => {
            return <Route exact path={route.path} component={route.component} key={route.path} />;
          })}
          <Redirect to={redirectPath} />
        </Switch>
      </Container>
    );
  };

  const RenderRoutes = () => {
    const role: Role = storeAuth?.isAuth
      ? user?.role
        ? (user?.role[0] as ROL)
        : 'PUBLIC'
      : 'PUBLIC';
    
    let routes: RouteItem[];
    // Si la ruta es /publicview, siempre usar rutas públicas
    if (window.location.pathname.startsWith('/publicview/')) {
      routes = [...commonRoutes, ...publicRoutes];
    } else if (role === 'PUBLIC') {
      if (window.location.pathname.includes('/meeting')) {
        routes = [...commonRoutes, ...meetingRoutes];
      } else {
        routes = [...commonRoutes, ...publicRoutes];
      }
    } else {
      routes = [...commonRoutes, ...meetingRoutes, ...roleRoutes[role]];
    }
    
    const redirectPath = redirectPaths[role];

    return (
      <Router>
        {window.location.pathname.startsWith('/publicview/') && (
          <RenderSwitch routes={routes} redirectPath={redirectPath} />
        )}

        {role === 'PUBLIC' && window.location.pathname.includes('/meeting') && (
          <RenderSwitch routes={routes} redirectPath={redirectPath} />
        )}

        {role === 'PUBLIC' && !window.location.pathname.includes('/meeting') && !window.location.pathname.startsWith('/publicview/') && (
          <LoginContainer>
            <RenderSwitch routes={routes} redirectPath={redirectPath} />
          </LoginContainer>
        )}

        {role !== 'PUBLIC' && !window.location.pathname.startsWith('/publicview/') && (
          <MenuBar role={role} roles={user.role}>
            <RenderSwitch routes={routes} redirectPath={redirectPath} />
          </MenuBar>
        )}
      </Router>
    );
  };

  return <RenderRoutes />;
};

export default Routes;
